import React, {PropsWithChildren, createContext, useCallback, useContext, useMemo, useState} from 'react';

type RecordVal = {
    imageRef: React.MutableRefObject<HTMLImageElement | null>;
    canvasesRef: React.MutableRefObject<Map<number, HTMLCanvasElement> | null>;
};
type ContextVal = Record<string, RecordVal>;

const ImageMarkupContext = createContext<{refsMap: ContextVal; addRef: (id: string, value: RecordVal) => void}>({
    refsMap: {},
    addRef: () => {
        throw new Error('ImageMarkupContext: addRef is not defined');
    },
});

export const useImageMarkupContext = (): {
    refsMap: ContextVal;
    addRef: (id: string, value: RecordVal) => void;
} => useContext(ImageMarkupContext);

function ImageMarkupProvider(props: PropsWithChildren<unknown>): JSX.Element {
    const {children} = props;

    const [refsMap, setRefsMap] = useState<ContextVal>({});

    const addRef = useCallback(
        (id: string, value: RecordVal): void => {
            setRefsMap((prev) => ({...prev, [id]: value}));
        },
        [setRefsMap]
    );

    const value = useMemo(() => ({refsMap, addRef}), [refsMap, addRef]);

    return <ImageMarkupContext.Provider value={value}>{children}</ImageMarkupContext.Provider>;
}

export default ImageMarkupProvider;
